import React from 'react';
import {Link} from "../../../plugins/gatsby-plugin-atollon";

const DistributorCard = (props) => {
    const {distributor} = props;
    return (
        <div className='card card--distributor'>
           <div className='card--distributor__inner'>
               {distributor.wholesaler && <h5>Wholesaler</h5>}
               {!distributor.wholesaler && distributor.retailer && <h5>Retailer</h5>}
               {distributor?.title && <h4>{distributor.title}</h4>}
               {distributor?.address && <p>{distributor.address}</p>}
               {distributor?.postcode && distributor.state && <p>{distributor.state.toUpperCase()} {distributor.postcode}</p>}

               <div className='card--distributor__contact'>
                    {distributor?.email && <p><span>E</span><Link to={`mailto:${distributor.email}`}>{distributor.email}</Link></p>}
                    {distributor?.phone && <p><span>P</span><Link to={`tel:${distributor.phone}`}>{distributor.phone}</Link></p>}
                    {distributor?.fax && <p><span>F</span><Link to={`fax:${distributor.fax}`}>{distributor.fax}</Link></p>}
                    {distributor?.website && <p><span>W</span><Link to={distributor.website} target='_blank' rel='noopener noreferrer'>{distributor.website}</Link></p>}
               </div>
           </div>
        </div>
    )
}

export default DistributorCard;